import { render } from "./TrangChu.vue?vue&type=template&id=e338cdd6&scoped=true"
import script from "./TrangChu.vue?vue&type=script&lang=js"
export * from "./TrangChu.vue?vue&type=script&lang=js"

import "./TrangChu.vue?vue&type=style&index=0&id=e338cdd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e338cdd6"]])

export default __exports__